import React from "react"; 
import IspPayTable from "./IspPayTable"; 
import BreadCrumb from "../../../../layout/BreadCrumb";
import ProjectDetails from "../../expression-of-interest/view/ProjectDetails";

function IspPayList() {
  return (
    <div>
      <BreadCrumb
        breadcrumbs={[
          { title: "Farmers", path: "/farmers-list" },
          { title: "Expression List", path: "/expression-view" },
          { title: "ISP Pay Form" },
        ]}
      />
      <ProjectDetails />
      <IspPayTable />
    </div>
  );
}

export default IspPayList;
